import { add, contains, qs, qsa, remove } from "@fluorescent/dom";
import Carousel from "@/lib/carousel";

import ProductItem from "@/lib/product-item";

const selectors = {
  slider: "[data-slider]",
  wrappingContainer: ".complementary-products",
  complementaryProducts: "[data-complementary-products]",
  complementaryProductsContent: "[data-complementary-products-content]",
};

const classes = {
  hasSlider: "complementary-products__content--has-slider",
  hidden: "hidden",
};

const complementaryProducts = node => {
  const complementaryProducts = qsa(selectors.complementaryProducts, node);

  if (!complementaryProducts.length) return;

  let productItems = [];
  let carousels = [];

  const {
    recommendationsType,
    productId: id,
    sectionId,
    layout,
    maxRecommendations,
  } = complementaryProducts[0].dataset;

  if (recommendationsType === "app-recommendations") {
    handleRecommendedProducts();
  } else {
    // Merchant is using custom product list
    complementaryProducts.forEach(block => {
      productItems.push(ProductItem(block));
    });

    initSlider();
  }

  function handleRecommendedProducts() {
    const requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${maxRecommendations}&product_id=${id}&intent=complementary`;

    fetch(requestUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;

        const recommendations = qs(
          selectors.complementaryProductsContent,
          html
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          complementaryProducts.forEach(
            block => (block.innerHTML = recommendations.innerHTML)
          );

          complementaryProducts.forEach(block => {
            productItems.push(ProductItem(block));
          });

          // Remove hidden flag as content has been fetched
          complementaryProducts.forEach(block => {
            remove(block.closest(selectors.wrappingContainer), classes.hidden);
          });

          initSlider();
        }
      })
      .catch(error => {
        throw error;
      });
  }

  function initSlider() {
    if (layout !== "slider") return;

    complementaryProducts.forEach(block => {
      const sliderElement = qs(selectors.slider, block);

      if (contains(sliderElement, classes.hasSlider)) {
        carousels.push(
          Carousel(block, "complementary-products", { wrapAround: false })
        );
        add(block, "slider-enabled");
      }
    });
  }

  function unload() {
    productItems.forEach(item => item.unload());
    carousels.forEach(carousel => carousel.destroy());
  }

  return { unload };
};

export default complementaryProducts;
